
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import AdminUsersTab from './AdminUsersTab';
import PropertyOwnersTab from './PropertyOwnersTab';

const UserManagementTabs = () => {
  return (
    <Tabs defaultValue="admins" className="w-full">
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger value="admins">Administradores</TabsTrigger>
        <TabsTrigger value="owners">Dueños de Propiedades</TabsTrigger>
      </TabsList>
      
      <TabsContent value="admins" className="mt-6">
        <AdminUsersTab />
      </TabsContent>
      
      <TabsContent value="owners" className="mt-6">
        <PropertyOwnersTab />
      </TabsContent>
    </Tabs>
  );
};

export default UserManagementTabs;
